import { HttpBackend, HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { mimeTypeToExtension } from "@shared/constants/mime-type-to-extension";

@Injectable({
  providedIn: "root"
})
export class DownloadFileService {
  private http: HttpClient;

  constructor(handler: HttpBackend) {
    // This is necessary to avoid the usage of the interceptor on the core module
    // It is also used when the front end needs to download a file from storage. Ex: https://smartfleetstorage.blob.core.windows.net/....
    this.http = new HttpClient(handler);
  }

  downloadFromUrl(
    url: string,
    fileName: string,
    hasExtensionInFileName?: boolean
  ): void {
    this.http.get(url, { responseType: "blob" }).subscribe((response: Blob) => {
      this.downloadFile(response, fileName, hasExtensionInFileName);
    });
  }

  downloadFromUrlPost(
    url: string,
    fileName: string,
    hasExtensionInFileName?: boolean
  ): void {
    this.http
      .post(url, null, { observe: "response", responseType: "blob" as "json" })
      .subscribe((response: HttpResponse<Blob>) => {
        this.downloadFile(response.body, fileName, hasExtensionInFileName);
      });
  }

  downloadFile(
    blob: Blob | File,
    fileName: string,
    hasExtensionInFileName: boolean = true
  ): void {
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveOrOpenBlob(blob);
      return;
    }

    const downloadName = `${fileName}${
      hasExtensionInFileName ? "" : mimeTypeToExtension[blob.type]
    }`;

    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = downloadName;
    downloadLink.dispatchEvent(
      new MouseEvent("click", { bubbles: true, cancelable: true, view: window })
    );
    setTimeout(() => {
      window.URL.revokeObjectURL(downloadLink.href);
      downloadLink.remove();
    }, 100);
  }
}
